<template>
  <header-client
    :compID="compID"
    :className="className"
    :activeKey="activeKey"
    @returnCompInfo="returnCompInfo"
    v-if="showClientHeader"
  ></header-client>
  <header-web
    :compID="compID"
    :className="className"
    :activeKey="activeKey"
    @returnCompInfo="returnCompInfo"
    v-else
  ></header-web>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import { ProductSelectionNotice } from '@/libs';
import HeaderClient from './components/header-client.vue'
import HeaderWeb from './components/header-web.vue'

export default {
  components: { HeaderClient, HeaderWeb },
  props: {
    compID: { default: 0 },
    activeKey: { default: '' },
    className: { default: '' },
  },
  data() {
    return {
      showClientHeader: CheckLibs.isClient() || CheckLibs.isInIframe()
    }
  },
  mounted() {
    this.showClientHeader = CheckLibs.isClient() || CheckLibs.isInIframe();
  },
  methods: {
    returnCompInfo(data) {
      window.parent.postMessage({
        key: ProductSelectionNotice.CompDetail,
        data: {
          CompId: data.CompId,
          CompName: data.CompName,
        }
      }, "*")
      this.$emit('returnCompInfo', data);
    },
  }
}
</script>
